<script>
    export default {
        data: function () {
            return {
                defaultFilter: {
                    type: 'new'
                },
            };
        },
        mounted: function () {
            this.$nextTick(() => {
                let filter = this.$refs.table.getFilter();
                this.load(filter.type ?? 'new');
            });
        },
        methods: {
            load: function (filterType) {
                this.defaultFilter.type = filterType;
                this.$refs.table.filterUpdate(this.defaultFilter);
                this.$refs.table.update();
            },
        },

        computed: {

        }
    }
</script>
